/* eslint-disable @typescript-eslint/no-unused-vars */
/** @jsx jsx */
import React from 'react';
import { useHistory } from 'react-router-dom';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import FormContents from 'components/atoms/Form/FormContents';
import { Container, Row, Col } from 'react-grid-system';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import moment from 'moment';
import BodyText from 'components/atoms/BodyText';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import { PrimaryButton, DeleteButton } from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import ShiftPatternDetailsStamp from 'components/organismos/master/labor/shiftPattern/ShiftPatternDetails/ShiftPatternDetailsStamp';
import TextForm from 'components/molecules/TextForm';
import FormField from 'components/atoms/Form/FormField';
import BlockUI from 'components/molecules/BlockUi';
import { grayScale, textColor, textFontSize } from 'components/styles';
import { css, jsx } from '@emotion/core';
import TabControl from 'components/atoms/TabControl';
import FormPadding from 'components/atoms/Form/FormPadding';
import { IchangeLog } from '../../../../organismos/master/attend/AttentStampForm/interface';
import { useStampModificationAddForm } from './hooks';
import ToastModal from '../../../../organismos/ToastModal';
import RadioSelectForm from "components/molecules/RadioSelectForm";
import HistoryApprovalTable from 'components/molecules/HistoryApprovalTable';
import FormTitle from 'components/atoms/Form/FormTitle';
import SelectForm from 'components/molecules/SelectForm';
import ChangeLogModal from 'components/molecules/ChangeLogModal';
import AttendStampModal from 'components/molecules/ChangeLogModal/Template/AttendStampModal';
import FormHeader from 'components/templates/FormHeader';

const styles = {
  formContent: {
    paddingBottom: '20px',
  },
  approvalWrap: css({
    padding: '0px',
    marginBottom: '15px',
    marginTop: '0px'
  }),
};

enum ActionType {
  Add = 0,
  Modify = 1,
  Delete = 2,
}

const StampModificationPage: React.FC = () => {
  const history = useHistory();
  const {
    formik,
    orgTreesOptions,
    staffName,
    attendBusinessOptions,
    targetDate,
    toastMessage,
    toastModalOpen,
    setToastModalOpen,
    confirmModalOpen,
    closeConfirmModal,
    stampList,
    setStampList,
    listTimes,
    isLoading,
    stampHistoryListAchievement,
    setStampHistoryListAchievement,
    selectChangelog,
    setSelectChangelog,
    remote,
    isRemote,
    setIsRemote,
    reasonList,
    reasonOptionList,
    reasonId,
    setReasonId,
  } = useStampModificationAddForm();

  const sortBy = React.useMemo(
    () => [
      {
        id: 'executiveCode',
        desc: false,
      },
    ],
    [],
  );

  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  return (
    <SidebarTemplate>
      <BlockUI blocking={isLoading}>
        <div>
          <form onSubmit={formik.handleSubmit}>
            <Container fluid={true}>
              {
                formik.values.deleteApplicationAvailable === false ? 
                <FormHeader title=" 打刻追加申請" />
                :  <FormHeader title="打刻修正申請"/>
              }
              <FormContents customStyle={css({marginTop:'60px'})}>
                <FormPadding>
                  <Row style={{ paddingTop: '8px'}}>
                    <Col md={2} xs={12}>
                      <BodyText>日時</BodyText>
                    </Col>
                    <Col md={6} xs={12}>
                      <BodyText color={textColor.mobileTitle}>
                        {moment(`${targetDate}`).format('YYYY年MM月DD日(ddd)')}
                      </BodyText>
                    </Col>
                  </Row>
                </FormPadding>
                <FormPadding>
                <Row >
                    <Col md={2} xs={12}>
                      <BodyText>スタッフ</BodyText>
                    </Col>
                    <Col md={6} xs={12}>
                      <BodyText color={textColor.mobileTitle}>
                        {staffName}
                      </BodyText>
                    </Col>
                  </Row>
               </FormPadding>
               
                {
                  (formik.values.modifierApplicationId === '' && formik.values.achievementId === '') && (
                    <FormPadding>
                    <Row >
                      <Col style={{ display: 'flex', alignItems: 'center' }} md={2}>
                        <BodyText>出勤組織</BodyText>
                      </Col>
                      <Col md={10}>
                        <Row>
                          <Col md={6}>
                            <SelectForm
                              label=""
                              name="orgCode"
                              value={String(formik.values.orgCode)}
                              setValue={(val: string) => formik.setFieldValue('orgCode', val)}
                              options={orgTreesOptions}
                              ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgTreesOptions.length === 1)}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    </FormPadding>
                 )
                }

                {
                  (formik.values.modifierApplicationId !== '' || formik.values.achievementId !== '') && (
                  <FormPadding>
                  <Row >
                    <Col xs={12}>
                      <Row>
                        <Col md={2} xs={12}>
                          <BodyText>出勤組織</BodyText>
                        </Col>
                        <Col md={6} xs={12}>
                          <BodyText color="#333333">
                            {formik.values.orgName}
                          </BodyText>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  </FormPadding>
                
                  )
                }
                { remote && (
                    <FormPadding>
                    <Row >
                    <Col style={{ display: 'flex', alignItems: 'center' }} md={2}>
                      <BodyText>出勤場所</BodyText>
                    </Col>
                    <Col md={10}>
                      <Row>
                        <Col md={4}>
                          <RadioSelectForm
                            items={[
                              {
                                label: "オフィス",
                                value: "false",
                              },
                              {
                                label: `${companyCode === 'HPo6wkyuze' ? '在宅勤務（自宅待機含む）' : 'テレワーク'}`,
                                value: "true",
                              },
                            ]}
                            name="isRemote"
                            value={String(isRemote)}
                            setValue={(e: any) => {
                              setIsRemote(e.target.value === 'true')
                            }}
                          />
                        </Col>
                    </Row>
                    </Col>
                  </Row>
                    </FormPadding>
         
                )}
                 <FormPadding>
                 <Row>
                  <Col style={{ display: 'flex', alignItems: 'center' }} md={2}>
                    <BodyText>申請事由</BodyText>
                  </Col>
                  <Col md={10}>
                      <Row>
                        <Col md={4} xs={12}>
                        <VerticalLabelSelectForm
                              label=""
                              name="reasonId"
                              value={String(formik.values.reasonId || '')}
                              setValue={(val: string) =>　 {
                                const applicationReason = reasonList.find((obj) => obj.reasonId === val)!;
                                if (applicationReason !== undefined && applicationReason.syncFlag === 1) {
                                  formik.setFieldValue('applicationReason', applicationReason.applicationReason);
                                } else if (applicationReason !== undefined && applicationReason.syncFlag === 0) {
                                  formik.setFieldValue('applicationReason', '');
                                }
                                formik.setFieldValue('reasonId', val)
                              }}
                              options={reasonOptionList}
                              width="480px"
                            />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
               
                 </FormPadding>
              
                <Row style={{ marginTop: '25px' }}>
                  <Col md={12} xs={12}>
                    <ShiftPatternDetailsStamp
                      shiftPatternDetailsList={stampList}
                      setShiftPatternDetailsList={setStampList}
                      attendBusinessOptions={attendBusinessOptions}
                      listTimes={listTimes}
                      remote={remote}
                      isDisableAll={formik.values.applicationStatus === 0}
                    /> 
                  </Col>
                </Row>
            
                <Row>
                  <Col
                    md={2}
                    offset={{ md: 1 }}
                    style={{
                      alignItems: 'center', justifyContent: 'center', display: 'flex', color: textColor.main, fontSize: '14px',
                    }}
                  >
                    申請理由
                  </Col>
                  <Col md={6}>
                    <FormField>
                      <TextForm
                        name="applicationReason"
                        label=""
                        value={String(formik.values.applicationReason)}
                        onChange={formik.handleChange}
                        errorMsg={formik.errors.applicationReason}
                        disable={formik.values.applicationStatus === 0}
                      />
                    </FormField>
                  </Col>
                </Row>

                
                <Row>
                  <Col md={6} offset={{ md: 3 }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom:'8px', paddingTop:'8px' }}>
                    <FormSubmitArea>
                      {
                        (!(formik.values.modifiyStatus === 1
                          && formik.values.applicationStatus === 0)) && (
                          <span style={{ marginRight: '10px' }}>
                            <PrimaryButton
                              ghost={false}
                              text="申請する"
                              disabled={formik.values.applicationStatus === 0}
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('buttonType', ActionType.Add);
                              }}
                            />
                          </span>
                        )
                      }
                      {
                        ((formik.values.applicationStatus === 0)) && (
                          <DeleteButton
                            ghost={false}
                            text="申請キャンセル"
                            onClick={() => {
                              formik.handleSubmit();
                              formik.setFieldValue('buttonType', ActionType.Modify);
                            }}
                          />
                        )
                      }

                      {
                        ((formik.values.deleteApplicationAvailable === true)) && (
                          <DeleteButton
                            ghost={false}
                            text="削除申請"
                            onClick={() => {
                              formik.handleSubmit();
                              formik.setFieldValue('buttonType', ActionType.Delete);
                            }}
                          />
                        )
                      }
                    </FormSubmitArea>
                  </Col>
                </Row>

                  <Row>
                    <Col md={6} offset={{ md: 3 }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom:'16px' }}>
                      <div style={{ marginRight: '12px' }}>
                        <PrimaryButton
                          onClick={() => history.goBack()}
                          text="キャンセル"
                          ghost={true}
                        />
                      </div>
                    </Col>
                  </Row>  

              </FormContents>
            </Container>
          </form>
        </div>

        <div style={{ paddingTop: 20 }}>
          <FormContents customStyle={styles.formContent}>
            <Row style={{ padding: '10px 15px' }}>
              <Col
                md={2}
                xs={12}
                style={{
                  fontWeight: 'bold', fontSize: textFontSize.md, lineHeight: '24px', paddingBottom: '20px', color: textColor.main,
                }}
              >
                更新履歴
              </Col>
            </Row>

            <TabControl
              isTabModal={true}
              isFixed={false}
              items={stampHistoryListAchievement.map((log: IchangeLog, index: number) => ({
                value: String(index),
                display: `ver${log.version}`,
              }))}
              setValue={setSelectChangelog as (arg: string) => void}
              currentValue={selectChangelog}
              styleNotActive={css({
                borderRadius: 0, border: 'none', width: '100px', flex: 'unset',
              })}
              styleActive={css({
                borderRadius: 0, border: 'none', borderBottom: '1px solid #007BC3', width: '100px', flex: 'unset',
              })}
            />
            {stampHistoryListAchievement.length > 0 && (stampHistoryListAchievement.map((itemLog: IchangeLog, index: number) => { 
              return (
                <div style={{ display: (selectChangelog !== String(index) ? 'none' : 'block') }}>

                  <React.Fragment>
                    <FormPadding customStyle={{ fontSize: '14px', color: textColor.mobileTitle }}>
                      <Row>
                        <Col
                          md={2}
                          xs={12}
                          style={{
                            fontSize: textFontSize.re, lineHeight: '24px', paddingBottom: '20px', color: `${grayScale.gray50}`,
                          }}
                        >
                          申請種別:
                      </Col>
                        <Col md={10} xs={12}>
                          {
                            itemLog.historyTypeName && (itemLog.historyTypeName)
                          }
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          md={2}
                          xs={12}
                          style={{
                            fontSize: textFontSize.re, lineHeight: '24px', paddingBottom: '20px', color: `${grayScale.gray50}`,
                          }}
                        >
                          申請者:
                      </Col>
                        <Col md={10} xs={12}>
                          {
                            itemLog.applicationStaffCode && `${itemLog.applicationStaffCode} `
                          }
                          {
                            itemLog.applicationStaffName && (itemLog.applicationStaffName)
                          }
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          md={2}
                          xs={12}
                          style={{
                            fontSize: textFontSize.re, lineHeight: '24px', paddingBottom: '20px', color: `${grayScale.gray50}`,
                          }}
                        >
                          申請日時:
                      </Col>
                        <Col md={10} xs={12}>
                          {
                            itemLog.applicationDate && (moment(itemLog.applicationDate).format('YYYY/MM/DD HH:mm:ss'))
                          }
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          md={2}
                          xs={12}
                          style={{
                            fontSize: textFontSize.re, lineHeight: '24px', paddingBottom: '10px', color: `${grayScale.gray50}`,
                          }}
                        >
                          出勤組織:
                      </Col>
                        <Col md={10} xs={12}>
                          {
                            itemLog.orgName && (itemLog.orgName)
                          }
                        </Col>
                      </Row>

                      <Row>
                        <AttendStampModal 
                          changeLogData={[itemLog]}
                          selectChangelog={String(index)}
                          isStamp={true}
                          customStyle={styles.approvalWrap} 
                        />
                      </Row>

                      <Row>
                        <Col
                          md={2}
                          xs={12}
                          style={{
                            fontSize: textFontSize.re, lineHeight: '24px', paddingBottom: '5px', color: `${grayScale.gray50}`,
                          }}
                        >
                          修正理由:
                        {itemLog.approvalHistoryList.length > 0 ?
                            <div style={{ fontSize: `${textFontSize.re}`, color: '#666666', paddingTop: '15px', fontWeight: 'bold' }}>承認状況</div> : ''}
                        </Col>
                        <Col md={10} xs={12}>
                          {
                            itemLog.applicationReason && (itemLog.applicationReason)
                          }
                        </Col>
                      </Row>
                      {/* <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: 'bold', fontSize: textFontSize.re, lineHeight: '24px', paddingBottom: '20px', color: textColor.main,
                        }}
                      >
                        承認日時:
                      </Col>
                      <Col md={10} xs={12}>
                        {itemLog.approvalDate && (moment(itemLog.approvalDate).format(
                          'YYYY/MM/DD HH:mm:ss',
                        ))}
                      </Col>
                    </Row> */}
                      {itemLog.approvalHistoryList.length >
                        0 && (
                          <Row>
                            <HistoryApprovalTable
                              historyData={
                                itemLog.approvalHistoryList
                              }
                              applicationStatus={itemLog.applicationStatus}
                            />
                          </Row>
                        )}
                    </FormPadding>
                  </React.Fragment>

                </div>
              )
            }

            ))}
          </FormContents>
        </div>

        <ToastModal
          open={toastModalOpen}
          closeHandler={() => setToastModalOpen(false)}
          title={toastMessage}
        />

        <ConfirmModal
          open={confirmModalOpen}
          closeHandler={closeConfirmModal}
          onSubmit={() => {
            formik.handleSubmit();
          }}
          title={formik.values.buttonType === 0 ? '打刻修正を申請'
            : formik.values.buttonType === 1 ? '申請キャンセルを申請' : '削除申請を申請'}
          // eslint-disable-next-line no-nested-ternary
          content={formik.values.buttonType === 0 ? '打刻修正を申請します。よろしいですか？'
            : formik.values.buttonType === 1 ? '申請キャンセルを申請します。よろしいですか？' : '削除申請を申請します。よろしいですか？'}
          // eslint-disable-next-line no-nested-ternary
          submitText="申請する"
          typeSubmit={formik.values.buttonType === 0 ? 'confirm' : 'reject'}
        />
      </BlockUI>
    </SidebarTemplate>
  );
};

export default StampModificationPage;
